import { render, staticRenderFns } from "./tab-view.vue?vue&type=template&id=20087d1a&scoped=true&"
import script from "./tab-view.vue?vue&type=script&lang=js&"
export * from "./tab-view.vue?vue&type=script&lang=js&"
import style0 from "./tab-view.vue?vue&type=style&index=0&id=20087d1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20087d1a",
  null
  
)

export default component.exports